<template>
  <div style="clear: both">
    <v-textarea
      name="justification"
      :label="$t('MOC_Justification')"
      :model-value="modelValue"
      auto-grow
      rows="1"
      variant="underlined"
      :readonly="readonly"
      v-on:update:model-value="updateValue"
      :rules="justificationRules"
      :error-messages="modelValue && modelValue.length > 0 ? null : ' '"
      :placeholder="$t('Rule_Required_MOCJustification')"
      dense
      density="comfortable"
      persistent-placeholder
    ></v-textarea>
  </div>
</template>

<script>
import { FormStatus, Roles } from '@/common'
import { Flags } from '@/common/flags'
export default {
  emits: ['update:modelValue'],
  name: 'JustificationField',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    roles: {
      type: Array,
      default: null
    },
    previousFormStatus: {
      type: Object
    },
    moc: {
      type: Object
    }
  },
  computed: {
    justificationRules: {
      get: function () {
        return [(v) => !!v || ' ']
      }
    },
    readonly: function () {
      switch (this.moc.status.value) {
        case FormStatus.properties[FormStatus.NEW].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          break
        case FormStatus.properties[FormStatus.DRAFT].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          break
        case FormStatus.properties[FormStatus.SUBMITTED].value:
          if (
            (this.moc.flags || []).includes(Flags.properties[Flags.MULTIPASS].key) &&
            (this.roles.includes(Roles.properties[Roles.FACILITATOR].value) ||
              this.roles.includes(Roles.properties[Roles.FACILITATORBACKUP].value) ||
              this.roles.includes(Roles.properties[Roles.OWNER].value))
          ) {
            return false
          }
          break
        case FormStatus.properties[FormStatus.AVAILABLETOIMPLEMENT].value:
          if (this.roles.includes(Roles.properties[Roles.OWNER].value)) {
            if ((this.moc.flags || []).includes(Flags.properties[Flags.OWNEREDITABLEMAKEPERMANENT].key)) {
              return false
            }
          }

          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return true
          }

          break
        case FormStatus.properties[FormStatus.SENTBACKFORCORRECTIONS].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          break
        case FormStatus.properties[FormStatus.BEINGREVISED].value:
          if (
            (this.previousFormStatus.value === FormStatus.properties[FormStatus.AVAILABLEFORDECISION].value ||
              this.previousFormStatus.value === FormStatus.properties[FormStatus.PENDINGOWNERDECISION].value ||
              this.previousFormStatus.value === FormStatus.properties[FormStatus.AVAILABLETOIMPLEMENT].value) &&
            (this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
              this.roles.includes(Roles.properties[Roles.COINITIATOR].value) ||
              this.roles.includes(Roles.properties[Roles.OWNER].value))
          ) {
            return false
          }

          if (
            this.previousFormStatus.value === FormStatus.properties[FormStatus.AVAILABLETOIMPLEMENT].value &&
            (this.roles.includes(Roles.properties[Roles.COORDINATOR].value) ||
              this.roles.includes(Roles.properties[Roles.OWNER].value))
          ) {
            return false
          }
          break
        case FormStatus.properties[FormStatus.TEMPORARYCHANGEISINPLACEWITHCONSEQUENTIALACTIONSREQUIRED].value:
          if (this.roles.includes(Roles.properties[Roles.OWNER].value)) {
            if ((this.moc.flags || []).includes(Flags.properties[Flags.OWNEREDITABLEMAKEPERMANENT].key)) {
              return false
            }
          }
          break
        default:
          return true
      }
      return true
    }
  },
  methods: {
    updateValue: function (value) {
      // this.$emit('input', value)
      this.$emit('update:modelValue', value)
    }
  }
}
</script>

<style scoped></style>
